export default __webpack_public_path__ + "static/media/stats.606980a9.svg";